import { api } from '../lib/api';
import { mapActions } from 'vuex';
import { infiniteLoading } from '../lib/customEvents';

export default {
  data() {
    return {
      filters: {},
      clients: {},
      totalClients: 0,
    };
  },

  methods: {
    ...mapActions('app', ['setLoading', 'setReferer', 'setFilters']),

    fullView(estimation) {
      this.setFilters({ status: estimation.status });
      this.setReferer(this.$route);
      this.$router.push({
        name: 'estimation-full-view',
        params: { id: estimation.id },
      });
    },

    async fetchClients(filters = {}) {
      this.filters = filters;

      this.setLoading({ value: true, message: 'loading-clients' });

      try {
        const response = await api.get(`api/clients`, { params: filters });

        this.setLoading({ value: false });

        return response && response.data;
      } catch (e) {
        this.setLoading({ value: false });
      }
    },

    async filterClients({ sortKey, value } = {}) {
      // Reset the page when filtering/ordering
      delete this.filters.page;

      if (sortKey) Object.assign(this.filters, { [sortKey]: value });

      const clientsCollection = await this.fetchClients(this.filters);

      if (!clientsCollection || !clientsCollection['hydra:member']) return;

      this.clients = clientsCollection['hydra:member'];

      if (!clientsCollection['hydra:totalItems']) return;

      this.totalClients = clientsCollection['hydra:totalItems'];

      this.$nextTick(() => document.dispatchEvent(infiniteLoading));
    },

    async paginateClients({ page, itemsPerPage }) {
      Object.assign(this.filters, { page, itemsPerPage });

      const clientsCollection = await this.fetchClients(this.filters);

      if (!clientsCollection || !clientsCollection['hydra:member']) return;

      this.clients.push(...clientsCollection['hydra:member']);
    },
  },
};
